import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=157f2888&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=js&"
export * from "./EventDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=157f2888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f2888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/owldesign/Sites/snowpeak/website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157f2888')) {
      api.createRecord('157f2888', component.options)
    } else {
      api.reload('157f2888', component.options)
    }
    module.hot.accept("./EventDetails.vue?vue&type=template&id=157f2888&scoped=true&", function () {
      api.rerender('157f2888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "development/vue-components/EventDetails.vue"
export default component.exports